export const SET_CLIENT_NAME = 'SET_CLIENT_NAME'

export function setClientName (clientName) {
  return {
    type: SET_CLIENT_NAME,
    clientName
  }
}
